module.exports = __webpack_public_path__ + "static/media/user-account-box.164181de.svg";